import { render, staticRenderFns } from "./Floors.vue?vue&type=template&id=217bfd19&"
import script from "./Floors.vue?vue&type=script&lang=js&"
export * from "./Floors.vue?vue&type=script&lang=js&"
import style0 from "./Floors.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Floors.vue"
export default component.exports